/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import update from 'immutability-helper';
import Form from "../Form";
import BaseResourceContainer from "../BaseResourceContainer";
import SchemaRegistry from "../../../services/SchemaRegistry";
import {deepCompare} from "../../../util";
import {PageActionActions, SubmitAction} from "../../../services/PageAction";

class EditForm extends BaseResourceContainer {
    static propTypes = {
        navResource: PropTypes.string,
        params: PropTypes.shape({
            resource: PropTypes.string.isRequired
        }).isRequired,
        schema: PropTypes.string.isRequired,
        location: PropTypes.object
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state.schema = this.getSchema(props);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onError = this.onError.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        if (this.props.params.resource !== nextProps.params.resource) {
            this.setState({
                schema: this.getSchema(nextProps)
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.params.resource !== this.props.params.resource ||
            nextProps.schema !== this.props.schema ||
            nextState !== this.state
        );
    }

    render() {
        let errors = this.getErrorList();
        return (
            <Form
                params={this.props.params}
                schema={this.state.schema}
                formData={this.state.resource.editRecord}
                errors={errors}
                onChange={this.onChange}
                onError={this.onError}
                onSubmit={this.onSubmit}
                location={this.props.location}
            />
        );
    }

    getSchema(props) {
        // If base resource is spceified then resource is actually a field below base resoruce. SchemaRegistry automatically loads correct
        // resource if this is specified in UI Schema.
        //return SchemaRegistry.getSchemaObject(props.params.parentResource, props.params.resource, props.schema);
        return SchemaRegistry.getSchemaObject(props.navResource, props.params.resource, props.schema);
    }

    onChange(data) {
        const normalizedData = Object.fromEntries(
            Object.entries(data).map(([key, val]) => {
                if (val === undefined || (typeof val === 'object' && val !== null && Object.keys(val).length === 0)) {
                    return [key, null];
                }
                return [key, val];
            })
        );
        this.clearChangedFieldErrors(normalizedData);
        this.actions().modifyEditRecord.defer(normalizedData);
    }

    onSubmit(data) {
        PageActionActions.callAction(new SubmitAction({data: data}));
    }

    onError(errors) {
        if (errors) this.actions().setErrorFlag.defer();
        else {
            // this.actions().setEditErrors.defer(null);
            this.actions().clearErrorFlag.defer();
        }
    }

    /**
     * Returns error information about the form data. Should be in the form:
     * {
     *      fieldName: errorMessage,
     *      fieldName: [errorMessage, ...]
     * }
     *
     * @return {Object}
     */
    getErrorList() {
        let action = this.state.resource.action;
        if (action) {
            let errorInfo = {};
            if (action.error && action.error.code === 400 && action.error.reason) {
                if (action.error.reason.startsWith("resource:")) {
                    let errorStr = action.error.reason.substring(9);
                    if (errorStr.indexOf("=") >= 0) {
                        let errors = errorStr.split(":");
                        for (let val of errors) {
                            let e = val.split("=");
                            if (_.has(errorInfo, e[0])) {
                                if (_.isArray(errorInfo[e[0]])) {
                                    errorInfo[e[0]].push(e[1]);
                                } else {
                                    errorInfo[e[0]] = [errorInfo[e[0]], e[1]];
                                }
                            } else {
                                errorInfo[e[0]] = e[1];
                            }
                        }
                    } else {
                        errorInfo[""] = action.error.message;
                    }
                } else if (action.error.reason.startsWith("element:") || action.error.reason.startsWith("param:")) {
                    // Single field error:
                    let errorItems = action.error.reason.split(":");
                    errorInfo[errorItems[1]] = action.error.message;
                } else {
                    // All other error messages:
                    errorInfo[""] = action.error.message;
                }
            }
            if (_.isEmpty(errorInfo)) {
                errorInfo = null;
            }
            this.actions().setEditErrors.defer(errorInfo);
            return errorInfo;
        } else {
            return this.state.resource.editErrors;
        }
    }

    /**
     * Clear external errors from fields where value is changed
     * @param data
     */
    clearChangedFieldErrors(data) {
        if (this.state.resource.editErrors && data && this.state.resource.editRecord) {
            let newEditErrors = this.state.resource.editErrors;
            let changed = false;
            for (let k of _.keys(this.state.resource.editErrors)) {
                if (deepCompare(data[k], this.state.resource.editRecord[k])) {
                    newEditErrors = update(newEditErrors, {$unset: [k]});
                    changed = true;
                }
            }
            if (changed) this.actions().setEditErrors.defer(newEditErrors);
        }
    }
}

export default EditForm;
